module.exports = __webpack_public_path__ + "static/media/chat.fbfab53b.svg";